import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chatSystemMessageDefaultVariants = {
  "appearance": "pill"
}
const chatSystemMessageCompoundVariants = []

const chatSystemMessageSlotNames = [
  [
    "root",
    "chatSystemMessage__root"
  ],
  [
    "content",
    "chatSystemMessage__content"
  ]
]
const chatSystemMessageSlotFns = /* @__PURE__ */ chatSystemMessageSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chatSystemMessageDefaultVariants, getSlotCompoundVariant(chatSystemMessageCompoundVariants, slotName))])

const chatSystemMessageFn = memo((props = {}) => {
  return Object.fromEntries(chatSystemMessageSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chatSystemMessageVariantKeys = [
  "appearance"
]
const getVariantProps = (variants) => ({ ...chatSystemMessageDefaultVariants, ...compact(variants) })

export const chatSystemMessage = /* @__PURE__ */ Object.assign(chatSystemMessageFn, {
  __recipe__: false,
  __name__: 'chatSystemMessage',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chatSystemMessageVariantKeys,
  variantMap: {
  "appearance": [
    "pill",
    "plain"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, chatSystemMessageVariantKeys)
  },
  getVariantProps
})